import { render, staticRenderFns } from "./ProjectExpanded.vue?vue&type=template&id=a1a65124&scoped=true"
import script from "./ProjectExpanded.vue?vue&type=script&lang=ts"
export * from "./ProjectExpanded.vue?vue&type=script&lang=ts"
import style0 from "./ProjectExpanded.vue?vue&type=style&index=0&id=a1a65124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a65124",
  null
  
)

export default component.exports